import { useEffect, useState } from 'react';
import Lenis from '@studio-freight/lenis';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import '@/App.css';

// Components
import { CustomCursor } from '@/components/CustomCursor';
import { SettingsProvider } from '@/SettingsContext';
import { useLanguage } from '@/LanguageContext';
import { Navigation } from '@/components/Navigation';
import { ScrollProgress } from '@/components/ScrollProgress';
import { SplashScreen } from '@/components/SplashScreen';
import { PageTransition } from '@/components/PageTransition';

// Pages
import { ProjectsPage } from '@/pages/ProjectsPage';
import { ProjectDetailPage } from '@/pages/ProjectDetailPage';
import { HomePage } from '@/pages/HomePage';
import { AdminPanel } from '@/components/AdminPanel';

export const LanguageToggle = () => {
  const { lang, toggleLanguage } = useLanguage();
  return (
    <button 
      onClick={toggleLanguage} 
      className="fixed bottom-6 right-6 z-[9999] px-4 py-2 font-mono text-xs uppercase tracking-widest text-white/50 hover:text-white border border-white/10 hover:border-white/30 bg-black/40 backdrop-blur-md rounded-full transition-all"
    >
      {lang === 'tr' ? 'EN' : 'TR'}
    </button>
  );
};

function App() {
  const location = useLocation();
  // İşte sitemizin kapı kilidi! Başlangıçta false (yani girilmedi)
  // ?preview=1 → admin panelin canlı önizleme iframe'i; splash atlanır
  const [hasEntered, setHasEntered] = useState(() => window.location.search.includes('preview=1'));

  useEffect(() => {
    const lenis = new Lenis({
      duration: 0.8,
      easing: (t) => 1 - Math.pow(1 - t, 3),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1.2,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

 useEffect(() => {
  const hash = sessionStorage.getItem('scrollTo');
  if (hash) {
    sessionStorage.removeItem('scrollTo');
    const tryScroll = (attempts = 0) => {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 200);
      } else if (attempts < 15) {
        setTimeout(() => tryScroll(attempts + 1), 200);
      }
    };
    tryScroll();
  } else if (!location.hash) {
    window.scrollTo(0, 0);
  }
}, [location.pathname, location.hash]);


 // Admin route'u — navigation, splash ekranı yok
  if (location.pathname.startsWith('/admin')) {
    return <AdminPanel />;
  }
  if (location.pathname.startsWith('/projects') || location.pathname.startsWith('/project/')) {
  return (
    <div className="dark App bg-black text-white min-h-screen overflow-x-hidden">
      <div className="noise-overlay" aria-hidden="true" />
      <CustomCursor />
      <Navigation />
      <LanguageToggle />
      <Routes location={location} key={location.pathname}>
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/project/:id" element={<ProjectDetailPage />} />
      </Routes>
    </div>
  );
}

  return (
  <div className="dark App bg-black text-white min-h-screen overflow-x-hidden">
    
    {/* 1. SİLİNEN GLOBAL EFEKTLERİ GERİ GETİRDİK (Cursor ve Noise) */}
    <div className="noise-overlay" aria-hidden="true" />
    <CustomCursor />
    <LanguageToggle />

    <AnimatePresence mode="wait">
      {/* 2. Açılış Ekranı */}
      {!hasEntered && (
        <SplashScreen key="splash" onEnter={() => {
          setHasEntered(true);
          window.scrollTo(0, 0); 
        }} />
      )}
    </AnimatePresence>

    {/* 3. Ana Site İçeriği */}
    {hasEntered && (
  <SettingsProvider>
    <>
        {/* Navigasyon en üstte ve her şeyden bağımsız! */}
        <Navigation /> 

        <motion.div
          key="main-site"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1.2, delay: 0.3, ease: [0.23, 1, 0.32, 1] }}
        >
          {/* ScrollProgress (Aşağı kaydırma çubuğu) da varsa onu da unutmayalım */}
          <ScrollProgress />
          
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/project/:id" element={<ProjectDetailPage />} />
            </Routes>
          </AnimatePresence>

        </motion.div>
     </>
  </SettingsProvider>
)}
  </div>
);
  
}


export default App;